var exports = {
  "l": "stickyHeader__OQ39Id",
};

module.exports = exports;
